// import * as index from '@/utils/index'
import query from '@/utils/query'
// import { mainRoutes } from '@/router'
// import qs from 'qs'

export default {
  data() {
    return {
      // tableHeight: index.getClientHeight() - 300,
      // 设置属性
      module: '', // 模块
      gridOptions: {
        isQuery: true, // 是否需要通过Query查询
        isAct: true, // 此页面是否在激活（进入）时，调用查询数据列表接口？
        isPage: true, // 数据列表接口，是否需要分页？
        isCount: true, // 是否查询数量
        listUrl: null, // 数据列表接口，API地址
        delUrl: null, // 删除接口，API地址
        exptUrl: null, // 导出接口，API地址
        auditUrl: null, // 审核通过接口，API地址
        enumUrl: null, // 枚举接口，API地址
        delKey: 'id', // 删除主键
        exptKey: 'id', // 导出主键
        auditKey: 'id', // 审核主键
        key: 'id', // 主键
      },
      // 默认属性
      key: 0,
      query: null,
      allParams: {}, // private只在私有参数
      params: {},
      defOrders: [], // 默认排序
      dataForm: {}, // 查询条件
      dataMode: {}, // 查询模式
      ruleName: {}, // 数据规则（定义规则名称）
      dataList: [], // 数据列表
      order: '', // 排序，asc／desc
      orderField: '', // 排序，字段
      pageNo: 1, // 当前页码
      pageSize: 10, // 每页数
      pageSizes: [5, 10, 20, 50, 100],
      total: 0, // 总条数
      dataListLoading: false, // 数据列表，loading状态
      dataListSelections: [], // 数据列表，多选项
      infoVisible: false, // 详情，弹窗visible状态
      editVisible: false, // 新增／更新，弹窗visible状态
      imptVisible: false, // 导入，弹窗visible状态
      exptVisible: false, // 导出，弹窗visible状态
      auditVisible: false, // 审核，弹窗visible状态
      searchStr: JSON.stringify(this.dataForm), // 解决查询条件变化，查询分页错误
      /** 字段过滤 */
      cols: [],
      checkCols: [],
    }
  },
  // 将 activated 回调函数变为mounted, 去掉keep-alive组件，防止页面缓存手动清空麻烦
  mounted() {
    this.setUrl()
    // this.setTableHeight()
    // window.addEventListener('resize', this.setTableHeight)
    if (this.gridOptions.isAct) {
      this.listData()
    }
    this.init()
    this.setCheckCols()
  },
  watch: {
    checkCols() {
      this.cols.filter((i) => {
        if (this.checkCols.indexOf(i.prop) !== -1) {
          i.show = true
        } else {
          i.show = false
        }
        /* this.$nextTick(() => {
          this.$refs.tableRef.doLayout()
        }) */
      })
    },
  },
  methods: {
    init() {},
    setUrl() {
      if (this.module) {
        if (!this.gridOptions.listUrl) {
          this.gridOptions.listUrl = this.module + 'page'
        }
        if (!this.gridOptions.delUrl) {
          this.gridOptions.delUrl = this.module + 'del'
        }
        if (!this.gridOptions.exptUrl) {
          this.gridOptions.exptUrl = this.module + 'expt'
        }
        if (!this.gridOptions.auditUrl) {
          this.gridOptions.auditUrl = this.module + 'audit'
        }
        if (!this.gridOptions.enumUrl) {
          this.gridOptions.enumUrl = '/sys/enum/list?cls='
        }
      }
    },
    // setTableHeight() {
    //   this.$nextTick(() => {
    //     this.tableHeight = index.getClientHeight() - 245
    //   })
    // },
    setCheckCols() {
      this.cols.forEach((itm) => {
        if (typeof itm.show === 'undefined' || itm.show === true) {
          this.checkCols.push(itm.prop)
        }
      })
    },
    // 获取数据列表
    async listData() {
      let currtSearchStr = JSON.stringify({ ...this.dataForm, ...this.params })
      // console.log(currtSearchStr)
      if (currtSearchStr !== this.searchStr) {
        this.pageNo = 1
        this.searchStr = currtSearchStr
      }

      this.dataListLoading = true
      let qryUrl = this.gridOptions.listUrl

      this.allParams = []
      // 是否需要query查询
      if (this.gridOptions.isQuery) {
        let qry = query.new()
        if (this.query) {
          qry = this.query
        }
        if (this.orderField !== '') {
          query.toO(qry, this.orderField, this.order)
        } else {
          if (this.defOrders.length > 0) {
            this.defOrders.forEach((item) => {
              query.toO(qry, item.k, item.t)
            })
          }
        }
        query.toF(qry, this.dataForm, this.dataMode, this.ruleName)
        // 是否需要分页
        if (this.gridOptions.isPage) {
          if (this.gridOptions.isCount) {
            query.toP(qry, this.pageNo, this.pageSize)
          } else {
            query.toP(qry, this.pageNo, this.pageSize, 1)
          }
        }
        // query.toJ(qry, 'mob', '123', 'LK', 'onSeg')
        qryUrl += '?query=' + encodeURIComponent(query.toJsonStr(qry))
        this.allParams = {
          ...this.params,
        }
      } else {
        this.allParams = {
          ...this.dataForm,
          ...this.params,
        }
        if (this.gridOptions.isPage) {
          this.allParams.pageNo = this.pageNo
          this.allParams.pageSize = this.pageSize
        }
      }
      // this.$http.get(this.gridOptions.listUrl + '?query=' + encodeURIComponent(query.toJsonStr(qry)) + '&_t=' + new Date().getTime(), {
      // await this.$http
      //   .get(qryUrl, {
      //     params: this.allParams,
      //   })
      await this.$http({ method: 'GET', url: qryUrl, params: this.allParams })
        .then((res) => {
          this.dataListLoading = false
          if (res.code !== 0) {
            this.dataList = []
            this.total = 0
            return this.$message.error(res.msg)
          }
          this.dataList = res.data.list
          this.handleListData()
          this.total = this.gridOptions.isPage ? res.page.total : 0
          if (!this.gridOptions.isCount) {
            this.total = 100000000
          }
          this.key = this.key + 1
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    handleListData() {},
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    // 分页, 每页条数
    sizeChangeHandle(val) {
      this.pageNo = 1
      this.pageSize = val
      console.log(val)
      this.listData()
    },
    // 分页, 当前页
    currentChangeHandle(val) {
      this.pageNo = val
      this.listData()
    },
    // 排序
    sortChangeHandle(data) {
      if (!data.order || !data.prop) {
        this.order = ''
        this.orderField = ''
        return false
      }
      this.pageNo = 1
      // this.order = data.order.replace(/ending$/, '')
      // this.orderField = data.prop.replace(/([A-Z])/g, '_$1').toLowerCase()
      this.order = data.order.replace(/ending$/, '')
      this.orderField = data.prop
      this.listData()
    },
    // 新增 / 修改
    editHandle(id) {
      this.editVisible = true
      this.$nextTick(() => {
        /* if (!id) {
          id = null
        } */
        this.$refs.edit.init(id)
      })
    },
    // tab 新增
    // addTabHandle (params) {
    //   // 组装路由名称, 并判断是否已添加, 如是: 则直接跳转
    //   let routeName = params.routeName || `${this.$route.name}-edit__新增`
    //   let route = window.SITE_CONFIG['dynamicRoutes'].filter(item => item.name === routeName)[0]
    //   if (route) {
    //     return this.$router.push({ name: routeName })
    //   }
    //   // 否则: 添加并全局变量保存, 再跳转
    //   route = {
    //     path: routeName,
    //     component: params.component,
    //     name: routeName,
    //     meta: {
    //       ...window.SITE_CONFIG['contentTabDefault'],
    //       menuId: this.$route.meta.menuId,
    //       title: params.titleName || `${this.$route.meta.title} -新增`
    //     }
    //   }
    //   this.$router.addRoutes([
    //     {
    //       ...mainRoutes,
    //       name: `main-dynamic__${route.name}`,
    //       children: [route]
    //     }
    //   ])
    //   window.SITE_CONFIG['dynamicRoutes'].push(route)
    //   this.$router.push({ name: route.name })
    // },
    // tab更新
    // updTabHandle(params) {
    //   // 组装路由名称, 并判断是否已添加, 如是: 则直接跳转
    //   let routeName = params.routeName || `${this.$route.name}-edit__params.id`
    //   let route = window.SITE_CONFIG['dynamicRoutes'].filter(item => item.name === routeName)[0]
    //   // var params = { 'id': row.id, 'nm': row.nm, 'cd': row.cd }
    //   if (route) {
    //     return this.$router.push({ name: routeName, params: params })
    //   }
    //   // 否则: 添加并全局变量保存, 再跳转
    //   route = {
    //     path: routeName,
    //     component: params.component,
    //     name: routeName,
    //     meta: {
    //       ...window.SITE_CONFIG['contentTabDefault'],
    //       menuId: this.$route.meta.menuId,
    //       title: params.titleName || `${this.$route.meta.title} - params.id`
    //     }
    //   }
    //   this.$router.addRoutes([
    //     {
    //       ...mainRoutes,
    //       name: `main-dynamic__${route.name}`,
    //       children: [route]
    //     }
    //   ])
    //   window.SITE_CONFIG['dynamicRoutes'].push(route)
    //   this.$router.push({ name: route.name, params: params })
    // },
    // 详情
    infoHandle(id) {
      this.infoVisible = true
      this.$nextTick(() => {
        this.$refs.info.init(id)
      })
    },
    // 导入
    // imptHandle() {
    //   this.imptVisible = true
    //   this.$nextTick(() => {
    //     this.$refs.impt.init()
    //   })
    // },

    // delHandle(id) {
    //   var ids = id
    //     ? [id]
    //     : this.dataListSelections.map((item) => {
    //         return item[this.gridOptions.delKey]
    //       })
    //   this.$confirm(`确定删除?`, '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning',
    //   })
    //     .then(() => {
    //       this.$http
    //         .get(this.gridOptions.delUrl, {
    //           params: { ids: ids.join(',') },
    //         })
    //         .then(({ data: res }) => {
    //           if (res && res.code === 0) {
    //             this.$message({
    //               message: '操作成功',
    //               type: 'success',
    //               duration: 500,
    //               onClose: () => {
    //                 this.listData()
    //               },
    //             })
    //           } else {
    //             this.$message.error(res.msg)
    //           }
    //         })
    //     })
    //     .catch(() => {})
    // },
    // 审核
    auditHandle0(id) {
      this.auditVisible = true
      this.$nextTick(() => {
        this.$refs.audit.init(id)
      })
    },
    auditPassHandle(id) {
      let params = {
        id: id,
        auditStatus: 1,
        auditRmks: '',
        tip: '通过',
      }
      this.auditHandle(params)
    },
    auditHandle(args) {
      var ids = args.id
        ? [args.id]
        : this.dataListSelections.map((item) => {
            return item[this.gridOptions.auditKey]
          })
      let params = {
        id: ids.join(','),
        auditStatus: args.auditStatus,
        auditRmks: args.auditRmks,
      }
      if (args.tip) {
        this.$confirm(`确定${args.tip}?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.auditDoHandle(params)
          })
          .catch(() => {})
      } else {
        this.auditDoHandle(params)
      }
    },
    // auditDoHandle(params) {
    //   this.$http.post(this.gridOptions.auditUrl, { ...params }).then(({ data: res }) => {
    //     if (res && res.code === 0) {
    //       this.$message({
    //         message: '操作成功',
    //         type: 'success',
    //         duration: 500,
    //         onClose: () => {
    //           this.listData()
    //           this.auditVisible = false
    //         },
    //       })
    //     } else {
    //       this.$message.error(res.msg)
    //     }
    //   })
    // },
    // baseHandle(config) {
    //   this.$confirm('确定' + config.message || '' + '?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning',
    //   })
    //     .then(() => {
    //       this.$http({
    //         url: config.url,
    //         method: config.method || 'get',
    //         params: config.params,
    //         data: config.data,
    //       }).then(({ data: res }) => {
    //         if (res && res.code === 0) {
    //           if (config.success) {
    //             config.success(res)
    //           }
    //           this.$message({
    //             message: '操作成功',
    //             type: 'success',
    //             duration: 500,
    //             onClose: () => {
    //               this.listData()
    //             },
    //           })
    //         } else {
    //           this.$message.error(res.msg)
    //         }
    //       })
    //     })
    //     .catch(() => {})
    // },
    // 列显控制
    show(prop) {
      if (this.cols.length === 0) {
        return true
      }
      let flag = false
      this.cols.forEach((itm) => {
        if (itm.prop === prop) {
          if (typeof itm.show === 'undefined' || itm.show === true) {
            flag = true
          }
          return flag
        }
      })
      return flag
    },
    // 枚举类获取参数
    listEnum(cls, arg) {
      return this.$http
        .get(this.gridOptions.enumUrl + cls)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          let args = arg.split('.')
          if (args.length === 3) {
            this[`${args[0]}`][`${args[1]}`][`${args[2]}`] = res.data.list
          } else if (args.length === 2) {
            this[`${args[0]}`][`${args[1]}`] = res.data.list
          } else {
            this[`${args[0]}`] = res.data.list
          }
        })
        .catch(() => {})
    },
    listObj(url, arg, qry) {
      this.$http
        .get(url + this.$query.toQ(qry))
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          let args = arg.split('.')
          if (args.length === 3) {
            this[`${args[0]}`][`${args[1]}`][`${args[2]}`] = res.data.list
          } else if (args.length === 2) {
            this[`${args[0]}`][`${args[1]}`] = res.data.list
          } else {
            this[`${args[0]}`] = res.data.list
          }
        })
        .catch(() => {})
    },
  },
}
